import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7733fce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: "pending",
  class: "button"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = {
  key: "addToBasket",
  class: "button button-hover"
}
const _hoisted_4 = { class: "button-text__label transition-transform duration-300 ease-in-out" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasketButtonContent',
  props: {
    defaultButtonText: null,
    addedButtonText: null,
    pending: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { defaultButtonText: string, addedButtonText: string, pending: boolean }



const enterAnimation = computed(() => {
    const animation = props.pending ? 'fadeInDown' : 'fadeInUp';
    return `${animation} animated u-anim-dur-300`;
});

const leaveAnimation = computed(() => {
    const animation = props.pending ? 'fadeOutDown' : 'fadeOutUp';
    return `${animation} animated u-anim-dur-300`;
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    "enter-active-class": _unref(enterAnimation),
    "leave-active-class": _unref(leaveAnimation)
  }, {
    default: _withCtx(() => [
      (__props.pending)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createVNode(_component_c_icon, {
              name: "icon-checkmark-medium",
              "aria-hidden": "true",
              class: "h-15 mr-5",
              width: "12"
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.addedButtonText), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.defaultButtonText), 1),
            _createVNode(_component_c_icon, {
              name: "icon-plus-small",
              "aria-hidden": "true",
              class: "button-text__icon transition-opacity duration-300 ease-in-out",
              width: "12",
              height: "12"
            })
          ]))
    ]),
    _: 1
  }, 8, ["enter-active-class", "leave-active-class"]))
}
}

})